
const ArrowIcon = () => (
  <svg viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m0 12 5-5-5-5 1-2 7 7-7 7-1-2Z" fill="#606060" />
  </svg>
)

export default ArrowIcon

